
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-ship-and-storage-works",
      function () {
        return require("private-next-pages/how-ship-and-storage-works/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-ship-and-storage-works"])
      });
    }
  